// SERVICE_TYPES mapping from metadata
export const SERVICE_TYPES = {
  CHECKING_VIOLATION: 1, // Tra cứu phạt nguội
  CREATE_TAG_VETC: 2, // Dán thẻ VETC
  PAY_VIOLATION_FEE: 3, // Đóng phí phạt nguội
  EXTEND_INSURANCE_TNDS: 4, // Gia hạn bảo hiểm TNDS
  PAY_VETC_FEE: 5, // Đóng phí VETC
  EXTEND_ISSURANCE_BODY: 6, // Gia hạn BH thân vỏ
  REPAIR_SERVICE: 7, // Bảo dưỡng, sửa chữa xe cơ giới
  INSPECT_CAR: 8, // Đăng kiểm xe cơ giới
  PAY_EPASS_FEE: 9, // Nạp tiền ePass
  HELP_SERVICE: 10, // Cứu hộ xe bị hư hỏng
  CONSULTATION_IMPROVEMENT: 11, // Tư vấn hoán cải
  AUTO_NOTIFY_VIOLATION: 12, // Tự động thông báo phạt nguội
  VEHICLE_INSPECTION: 13, // Đăng kiểm xe cũ
  REGISTER_NEW_VEHICLE: 14, // Nộp hồ sơ xe mới
  CHANGE_REGISTATION: 15, // Đổi mục đích sử dụng, đổi chủ, đổi thông tin hồ sơ
  PAY_ROAD_FEE: 16, // Thanh toán phí đường bộ
  CONSULTANT_MAINTENANCE: 18, // Đặt lịch tư vấn bảo dưỡng
  CONSULTANT_INSURANCE: 19, // Đặt lịch tư vấn bảo hiểm
  LOST_REGISTRATION_PAPER: 20, // Mất giấy đăng kiểm
  REISSUE_INSPECTION_STICKER: 21, // Cấp lại tem đăng kiểm
  VEHICLE_INSPECTION_CONSULTATION: 22, // Tư vấn đăng kiểm xe
  TRAFFIC_FINE_CONSULTATION: 23, // Tư vấn xử lý phạt nguội
  CONSULTANT_TNDS_INSURANCE: 24, // Tư vấn bảo hiểm TNDS xe ô tô
  AUTO_NOTIFY_VIOLATION_2: 25, // Tra cứu cảnh báo đăng kiểm
  SUPPORT_FINE_RESOLUTION: 26, // Hỗ trợ xử lý phạt nguội
  GPS_RENEWAL: 27, // Gia hạn định vị
  BUSINESS_VEHICLE_BADGE_RENEWAL: 28, // Gia hạn phù hiệu xe kinh doanh
  TRAINING_CERTIFICATE_RENEWAL: 29, // Gia hạn giấy tập huấn
  DASHCAM_RENEWAL: 30, // Gia hạn camera hành trình
  TNDS_INSURANCE_RENEWAL: 31, // Gia hạn BH TNDS
  OFF_HOUR_NEW_VEHICLE_REGISTER: 32, // Nộp hồ sơ xe mới (Ngoài giờ HC)
  OFF_HOUR_VEHICLE_INSPECTION: 33, // Đăng kiểm xe (Ngoài giờ HC)
  DRIVER_HEALTH: 34, // Khám sức khỏe lái xe
  CONSULTANT_INSURANCE_COMPENSATION: 35, // Tư vấn bồi thường bảo hiểm
  GATE_TICKET: 36, // Vé vào cổng
  BRIDGE_TICKET: 37, // Vé cầu
  TRIP_TICKET: 38, // Vé lượt
  CAR_CARE: 39, // Chăm sóc xe
  CAR_WASH: 40, // Rửa xe
  STATION_CUSTOM_SERVICE: 10000 // Dịch vụ riêng do trạm tạo
};

export const INSPECTION_AND_DOCUMENT_SERVICES = [
  SERVICE_TYPES.VEHICLE_INSPECTION, // 13
  SERVICE_TYPES.INSPECT_CAR, // 8
  SERVICE_TYPES.OFF_HOUR_VEHICLE_INSPECTION, // 33
  SERVICE_TYPES.REISSUE_INSPECTION_STICKER, // 21
  SERVICE_TYPES.LOST_REGISTRATION_PAPER, // 20
  SERVICE_TYPES.REGISTER_NEW_VEHICLE, // 14
  SERVICE_TYPES.OFF_HOUR_NEW_VEHICLE_REGISTER, // 32
  SERVICE_TYPES.CHANGE_REGISTATION, // 15
];

export const VIOLATION_AND_FINE_SERVICES = [
  SERVICE_TYPES.CHECKING_VIOLATION, // 1
  SERVICE_TYPES.PAY_VIOLATION_FEE, // 3
  SERVICE_TYPES.SUPPORT_FINE_RESOLUTION, // 26
  SERVICE_TYPES.AUTO_NOTIFY_VIOLATION, // 12
];

export const INSURANCE_SERVICES = [
  SERVICE_TYPES.EXTEND_INSURANCE_TNDS, // 4
  SERVICE_TYPES.EXTEND_ISSURANCE_BODY, // 6
  SERVICE_TYPES.TNDS_INSURANCE_RENEWAL, // 31
];

export const MAINTENANCE_AND_RENOVATION_SERVICES = [
  SERVICE_TYPES.REPAIR_SERVICE, // 7
  SERVICE_TYPES.CAR_CARE, // 39
  SERVICE_TYPES.CAR_WASH, // 40
  SERVICE_TYPES.HELP_SERVICE, // 10
];

export const E_TOLL_AND_TICKET_SERVICES = [
  SERVICE_TYPES.PAY_ROAD_FEE, // 16
  SERVICE_TYPES.CREATE_TAG_VETC, // 2
  SERVICE_TYPES.PAY_VETC_FEE, // 5
  SERVICE_TYPES.PAY_EPASS_FEE, // 9
];

export const E_TICKET_SERVICES = [
  SERVICE_TYPES.BRIDGE_TICKET, // 37
  SERVICE_TYPES.GATE_TICKET, // 36
  SERVICE_TYPES.TRIP_TICKET, // 38
];

export const RENEWAL_SERVICES = [
  SERVICE_TYPES.BUSINESS_VEHICLE_BADGE_RENEWAL, // 28
  SERVICE_TYPES.GPS_RENEWAL, // 27
  SERVICE_TYPES.DASHCAM_RENEWAL, // 30
  SERVICE_TYPES.TRAINING_CERTIFICATE_RENEWAL, // 29
  SERVICE_TYPES.DRIVER_HEALTH, // 34
];

export const CONSULTATION_AND_OTHER_SERVICES = [
  SERVICE_TYPES.CONSULTATION_IMPROVEMENT, // 11
  SERVICE_TYPES.CONSULTANT_MAINTENANCE, // 18
  SERVICE_TYPES.CONSULTANT_INSURANCE, // 19
  SERVICE_TYPES.VEHICLE_INSPECTION_CONSULTATION, // 22
  SERVICE_TYPES.TRAFFIC_FINE_CONSULTATION, // 23
  SERVICE_TYPES.CONSULTANT_TNDS_INSURANCE, // 24
  SERVICE_TYPES.CONSULTANT_INSURANCE_COMPENSATION, // 35
];

export const SERVICE_CATEGORY_OPTIONS = [
  { label: 'Đăng kiểm & thủ tục xe', value: 1 },
  { label: 'Phạt nguội & vi phạm giao thông', value: 2 },
  { label: 'Bảo hiểm xe', value: 3 },
  { label: 'Phí & dịch vụ giao thông', value: 5 },
  { label: 'Vé điện tử', value: 6 },
  { label: 'Bảo dưỡng & chăm sóc xe', value: 4 },
  { label: 'Giấy phép & điều kiện kinh doanh', value: 7 },
  { label: 'Tư vấn & dịch vụ khác', value: 8 },
];

export const PAYMENT_MODES = {
  ONLINE: {
    key: 'enableOnlinePayment',
    label: 'Thanh toán online',
  },
  COLLECTION: {
    key: 'enablePaymentCollection',
    label: 'Thu hộ',
  },
  PREPAY: {
    key: 'enablePrepay',
    label: 'Thu trước',
  },
};


export const SERVICE_CATEGORIES = {
  INSPECTION_AND_DOCUMENT: 1,
  VIOLATION_AND_FINE: 2,
  INSURANCE: 3,
  MAINTENANCE_AND_RENOVATION: 4,
  E_TOLL_AND_TICKET: 5,
  E_TICKET: 6,
  RENEWAL: 7,
  OTHER: 8,
};

export const PARENT_SERVICE_TYPES = {
  INSPECTION_AND_DOCUMENT: 1,
  VIOLATION_AND_FINE: 2,
  INSURANCE: 3,
  MAINTENANCE_AND_RENOVATION: 4,
  E_TOLL_AND_TICKET: 5,
  E_TICKET: 6,
  RENEWAL: 7,
  OTHER: 8,
};

export const FILTER_BUTTONS = [
  { label: 'Tất cả dịch vụ', filterArray: null, key: 'all' },
  { label: 'Đăng kiểm & thủ tục xe', filterArray: INSPECTION_AND_DOCUMENT_SERVICES, key: SERVICE_CATEGORIES.INSPECTION_AND_DOCUMENT },
  { label: 'Phạt nguội & vi phạm giao thông', filterArray: VIOLATION_AND_FINE_SERVICES, key: SERVICE_CATEGORIES.VIOLATION_AND_FINE },
  { label: 'Bảo hiểm xe', filterArray: INSURANCE_SERVICES, key: SERVICE_CATEGORIES.INSURANCE },
  { label: 'Phí & dịch vụ giao thông', filterArray: E_TOLL_AND_TICKET_SERVICES, key: SERVICE_CATEGORIES.E_TOLL_AND_TICKET },
  { label: 'Vé điện tử', filterArray: E_TICKET_SERVICES, key: SERVICE_CATEGORIES.E_TICKET },
  { label: 'Bảo dưỡng & chăm sóc xe', filterArray: MAINTENANCE_AND_RENOVATION_SERVICES, key: SERVICE_CATEGORIES.MAINTENANCE_AND_RENOVATION },
  { label: 'Giấy phép & điều kiện kinh doanh', filterArray: RENEWAL_SERVICES, key: SERVICE_CATEGORIES.RENEWAL },
  { label: 'Tư vấn & dịch vụ khác', filterArray: CONSULTATION_AND_OTHER_SERVICES, key: SERVICE_CATEGORIES.OTHER },
];

export const getDerivedParentServiceType = (service = {}) => {
  const parentServiceType = Number(service?.parentServiceType);
  if (parentServiceType) {
    return parentServiceType;
  }
  const serviceType = service?.serviceType;
  const matched = FILTER_BUTTONS.find(
    (btn) => Array.isArray(btn.filterArray) && btn.filterArray.includes(serviceType)
  );
  if (matched && matched.key !== 'all') {
    return matched.key;
  }
  return PARENT_SERVICE_TYPES.OTHER;
};

export const EXTRA_SERVICES = [
  SERVICE_TYPES.CHECKING_VIOLATION, // 1
  SERVICE_TYPES.CREATE_TAG_VETC, // 2
  SERVICE_TYPES.PAY_VIOLATION_FEE, // 3
  SERVICE_TYPES.EXTEND_INSURANCE_TNDS, // 4
  SERVICE_TYPES.PAY_VETC_FEE, // 5
  SERVICE_TYPES.EXTEND_ISSURANCE_BODY, // 6
  SERVICE_TYPES.REPAIR_SERVICE, // 7
  SERVICE_TYPES.INSPECT_CAR, // 8
  SERVICE_TYPES.PAY_EPASS_FEE, // 9
  SERVICE_TYPES.HELP_SERVICE, // 10
  SERVICE_TYPES.CONSULTATION_IMPROVEMENT, // 11
  SERVICE_TYPES.PAY_ROAD_FEE, // 16
  SERVICE_TYPES.AUTO_NOTIFY_VIOLATION_2, // 25
  SERVICE_TYPES.SUPPORT_FINE_RESOLUTION, // 26
  SERVICE_TYPES.GPS_RENEWAL, // 27
  SERVICE_TYPES.BUSINESS_VEHICLE_BADGE_RENEWAL, // 28
  SERVICE_TYPES.TRAINING_CERTIFICATE_RENEWAL, // 29
  SERVICE_TYPES.DASHCAM_RENEWAL, // 30
  SERVICE_TYPES.TNDS_INSURANCE_RENEWAL, // 31
  SERVICE_TYPES.OFF_HOUR_NEW_VEHICLE_REGISTER, // 32
  SERVICE_TYPES.OFF_HOUR_VEHICLE_INSPECTION, // 33
  SERVICE_TYPES.DRIVER_HEALTH, // 34
  SERVICE_TYPES.GATE_TICKET, // 36
  SERVICE_TYPES.BRIDGE_TICKET, // 37
  SERVICE_TYPES.TRIP_TICKET // 38
];

export default {
  SERVICE_TYPES,
  INSPECTION_AND_DOCUMENT_SERVICES,
  VIOLATION_AND_FINE_SERVICES,
  INSURANCE_SERVICES,
  MAINTENANCE_AND_RENOVATION_SERVICES,
  E_TOLL_AND_TICKET_SERVICES,
  E_TICKET_SERVICES,
  RENEWAL_SERVICES,
  CONSULTATION_AND_OTHER_SERVICES,
  PAYMENT_MODES,
  SERVICE_CATEGORY_OPTIONS,
  SERVICE_CATEGORIES,
  PARENT_SERVICE_TYPES,
  FILTER_BUTTONS,
  getDerivedParentServiceType,
};
